// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .if-logged {
  display: none;
}
:host .if-not-logged {
  display: inline-block;
}
:host .loyalitix-container {
  padding: 1rem;
  background-color: var(--ion-color-primary);
  color: white;
}
:host .points-card-container {
  padding: 1rem;
  background-color: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
:host .points-card-container .points-title {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 1.2rem;
  margin-bottom: 1rem;
}
:host .points-card-container .points-title img {
  height: 35px;
}
:host .points-card-container .user-title {
  font-weight: bold;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}
:host .points-card-container .total-points {
  background-color: var(--ion-color-primary-contrast);
  color: var(--ion-color-danger);
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 10px;
  width: auto;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
}
:host .points-card-container .total-points ion-icon {
  font-size: 120%;
}

:host-context(.logged) .if-logged {
  display: inline-block;
}
:host-context(.logged) .if-not-logged {
  display: none;
}

.page-home__content {
  --padding-start: 0;
  --padding-end: 0;
}

.page-home__skeleton {
  padding: 8px 0 16px;
}

.page-home__skeleton-item {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.scss"],"names":[],"mappings":"AACI;EACI,aAAA;AAAR;AAGI;EACI,qBAAA;AADR;AAII;EACI,aAAA;EACA,0CAAA;EACA,YAAA;AAFR;AAKI;EACI,aAAA;EACA,0CAAA;EACA,wCAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;AAHR;AAKQ;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AAHV;AAKU;EACE,YAAA;AAHZ;AAOQ;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;AALV;AAQQ;EACE,mDAAA;EACA,8BAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACJ,mBAAA;AANN;AAQM;EACE,eAAA;AANR;;AAaI;EACI,qBAAA;AAVR;AAaI;EACI,aAAA;AAXR;;AAeA;EACE,kBAAA;EACA,gBAAA;AAZF;;AAeA;EACE,mBAAA;AAZF;;AAeA;EACE,cAAA;AAZF","sourcesContent":[":host{\n    .if-logged{\n        display: none;\n    }\n\n    .if-not-logged{\n        display: inline-block;\n    }\n\n    .loyalitix-container{\n        padding: 1rem;\n        background-color: var(--ion-color-primary);\n        color: white;\n    }\n\n    .points-card-container{\n        padding: 1rem;\n        background-color: var(--ion-color-primary);\n        color: var(--ion-color-primary-contrast);\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: center;\n    \n        .points-title{\n          width: 100%;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          font-weight: bold;\n          font-size: 1.2rem;\n          margin-bottom: 1rem;\n    \n          img{\n            height: 35px;\n          }\n        }\n    \n        .user-title{\n          font-weight: bold;\n          font-size: 1.5rem;\n          margin-bottom: 1rem;\n        }\n    \n        .total-points{\n          background-color: var(--ion-color-primary-contrast);\n          color: var(--ion-color-danger);\n          padding: 0.5rem 1rem;\n          font-size: 1rem;\n          border-radius: 10px;\n          width: auto;\n          font-weight: 500;\n          display: inline-flex;\n      align-items: center;\n\n      ion-icon{\n        font-size: 120%;\n      }\n        }\n      }\n}\n\n:host-context(.logged){\n    .if-logged{\n        display: inline-block;\n    }\n\n    .if-not-logged{\n        display: none;\n    }\n}\n\n.page-home__content {\n  --padding-start: 0;\n  --padding-end: 0;\n}\n\n.page-home__skeleton {\n  padding: 8px 0 16px;\n}\n\n.page-home__skeleton-item {\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
